import { Box, CircularProgress, Grid } from "@mui/material";
import { InnerWrapper, MainContainer, TitleAndActionBox } from "../../common";
import { Fragment, useContext, useEffect, useState } from "react";
import { LanguageContext } from "../../../context/LanguageContext";
import SuccessImage from "../../../assets/images/successImage.png";
import styles from "./styles.module.css";
import { ParagraphText, UBButton } from "../../../Libraries";
import { hasUnsyncedChanges } from "@nozbe/watermelondb/sync";
import { database } from "../../../database";
import { useLocation, useNavigate } from "react-router-dom";
import { analytics, triggerLogEvent } from "../../../config/firebase";
import moment from "moment";
import { useAuthContext } from "../../../context/AuthContext";
import { useSnackbar } from "../../../context/SnackbarContext";
import { Sync } from "../../../SyncService";
import {
  NewCheckMarkRoundIcon,
  RotateNewIcon,
} from "../../../assets/icons/icon";

function BackupData() {
  const [I18n] = useContext(LanguageContext);
  const navigate = useNavigate();
  const { user } = useAuthContext();
  const { showSnackbar } = useSnackbar();
  const location = useLocation();

  const { isBackup } = location.state || {};

  const [backupLoading, setBackupLoading] = useState(false);
  const [isBackupSuccess, setBackupSuccess] = useState(false);
  const [isSynced, setIsSynced] = useState(false);
  const [isError, setIsError] = useState(false);
  const [lastBackuptime, setLastBackuptime] = useState("");

  useEffect(() => {
    checkForBackup();
  }, []);

  useEffect(() => {
    if (user?.phone_number) refreshLastBackupTime();
  }, [user?.phone_number]);

  const refreshLastBackupTime = () => {
    const raw = localStorage.getItem(user.phone_number);
    if (!raw) return;
    const ts = Number(raw);
    setLastBackuptime(
      moment(ts < 1e12 ? ts * 1000 : ts).format("DD MMM, YYYY - hh:mm A"),
    );
  };

  const checkForBackup = async () => {
    const syncStatus = await hasUnsyncedChanges({ database });
    setIsSynced(!syncStatus);
    if (isBackup) {
      backup();
    }
  };

  const backup = () => {
    try {
      if (!navigator.onLine) {
        showSnackbar({
          message: I18n.internet_connection_is_required,
          severity: "error",
        });
        return;
      }
      setBackupLoading(true);
      Sync(user.phone_number, navigate)
        .then(() => {
          triggerLogEvent(analytics, "setting_backup_sync", {});
          localStorage.setItem(user.phone_number, Date.now().toString());
          refreshLastBackupTime();
          setIsSynced(true);
          setIsError(false);
          setBackupLoading(false);
          setBackupSuccess(true);
          const timer = setTimeout(() => setBackupSuccess(false), 2000);
          return () => clearTimeout(timer);
        })
        .catch((err) => {
          triggerLogEvent(analytics, "backup_failed", {});
          setIsSynced(false);
          setIsError(true);
          setBackupLoading(false);
        });
    } catch (e) {}
  };

  const statusText = isBackupSuccess
    ? I18n.backup_success
    : isError
      ? I18n.backup_not_successful
      : isSynced
        ? I18n.your_data_backup_is_up_to_date
        : I18n.backup_your_data;

  return (
    <MainContainer fluid className="quickSalePage">
      <Grid container>
        <Grid item md={12}>
          <TitleAndActionBox data={{ title: I18n.backup }} />

          <InnerWrapper className="innerWrapper newInnerWrapper">
            <Box className={styles.mainContainer}>
              {backupLoading ? (
                <Box className={styles.loadingContainer}>
                  <CircularProgress size="50px" color="primary" />
                  <ParagraphText className="fontSize24 fontWeight500 newFontColor textCenter">
                    {I18n.uploading_your_backup_please_wait}
                  </ParagraphText>
                </Box>
              ) : (
                <Fragment>
                  {isSynced && !isError ? (
                    <NewCheckMarkRoundIcon width="60px" height="60px" />
                  ) : (
                    <RotateNewIcon width="60px" height="60px" />
                  )}

                  <Box className={styles.textContainer}>
                    <ParagraphText className="fontSize24 fontWeight500 newFontColor textCenter">
                      {statusText}
                    </ParagraphText>
                    {lastBackuptime ? (
                      <ParagraphText className="fontSize14 fontWeight400 newLightColor textCenter">
                        {`${I18n.last_backup_time} (${lastBackuptime})`}
                      </ParagraphText>
                    ) : null}
                  </Box>

                  <UBButton
                    onClick={backup}
                    id="backup_data"
                    className="ubPrimaryButton fontSize14 fontWeight400 textUppercase"
                    title={!isSynced ? I18n.backup_now : I18n.backup_data}
                  />
                </Fragment>
              )}
            </Box>
          </InnerWrapper>
        </Grid>
      </Grid>
    </MainContainer>
  );
}

export default BackupData;
